import { render, staticRenderFns } from "./MaterialTemplateInputItem.vue?vue&type=template&id=72354fad&scoped=true"
import script from "./MaterialTemplateInputItem.vue?vue&type=script&lang=ts"
export * from "./MaterialTemplateInputItem.vue?vue&type=script&lang=ts"
import style0 from "./MaterialTemplateInputItem.vue?vue&type=style&index=0&id=72354fad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72354fad",
  null
  
)

export default component.exports